import {
    ToolPropertiesFormComponent
} from '@app/tool/components/tool-batch-update-modal/forms/tool-properties-form/tool-properties-form.component';
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ToolService } from '@app/core/services/tool.service';
import { TranslateService } from "@ngx-translate/core";
import { Log } from "ng2-logger";
import { Tool } from "@app/tool/model/tool.model";
import { ToolSet } from "@app/tool/model/toolSet.model";
import { WizardModalComponent } from "@app/shared/components";
import { ToolBulkUpdate } from "@app/tool/components/tool-batch-update-modal/models/tool-bulk-update.model";

class ToolSteps {
    static RESPONSIBLE = 0;
    static OVERVIEW = 1;
}

@Component({
    selector: 'app-tool-bulk-update-modal',
    templateUrl: 'tool-bulk-update-modal.component.html',
    styleUrls: ['tool-bulk-update-modal.component.scss']
})
export class ToolBulkUpdateModalComponent implements AfterViewInit {
    _logger = Log.create(ToolBulkUpdateModalComponent.name);

    @ViewChild(WizardModalComponent, {static: false}) wizardModal: WizardModalComponent;
    // 1st Step
    @ViewChild(ToolPropertiesFormComponent, {static: false}) toolPropertiesForm: ToolPropertiesFormComponent;

    @Input() isLoading = false;

    @Output() onUpdate = new EventEmitter();
    @Output() onDelete = new EventEmitter();

    @Output() onClose = new EventEmitter();

    props = null;
    selectedStep: number;
    selectedTools: Array<ToolSet | Tool> = [];

    constructor(private cdr: ChangeDetectorRef,
                private translationService: TranslateService,
                private toolService: ToolService) {
    }

    onStepChange(stepIndex) {
        this.selectedStep = stepIndex;
        switch (stepIndex) {
            case ToolSteps.RESPONSIBLE:
                break;
            default:
                break;
            case ToolSteps.OVERVIEW:
                if (this.toolPropertiesForm.valid) {
                    this.props = this.toolPropertiesForm;
                }
                break;
        }
    }

    onWizardSubmit() {
        this.onUpdate.emit(new ToolBulkUpdate({
                tools: this.selectedTools,
                changes: {
                    owner: this.toolPropertiesForm?.value?.owner,
                    toolAvailability: this.prodValidityValue,
                    toolAvailabilityReason: this.prodValidityReason
                }
            })
        );
    }

    onWizardCancel() {
        this.reset();
        this.close();
        this.toolService.getTools();
    }

    open(selectedTools: Array<ToolSet | Tool> = []) {
        this.selectedTools = selectedTools;
        this.wizardModal.open();
    }

    close() {
        this.reset();
        this.wizardModal.close();
        this.selectedTools = [];
    }

    reset() {
        this.props = null;
        this.selectedTools = [];
        if (this.toolPropertiesForm) {
            this.toolPropertiesForm.resetForm();
        }
        this.wizardModal.reset();
    }

    get toolPropertiesValid() {
        return this.toolPropertiesForm ? this.toolPropertiesForm.valid : false;
    }

    get hasChanges() {
        return this.toolPropertiesForm && (this.toolPropertiesForm.control('owner')?.value ||
            this.toolPropertiesForm.control('validForProduction')?.value === true ||
            this.toolPropertiesForm.control('notValidForProduction')?.value === true);
    }

    get ownerProp() {
        return this.toolPropertiesForm &&
        this.toolPropertiesForm.control('owner')?.value ?
            this.toolPropertiesForm.control('owner')?.value.fullName : '';
    }

    get prodValidityProp() {
        return this.toolPropertiesForm && (this.toolPropertiesForm.control('validForProduction')?.value === true ||
            this.toolPropertiesForm.control('notValidForProduction')?.value === true)
    }

    get prodValidityText() {
        if (this.toolPropertiesForm?.control('validForProduction')?.value === true) {
            return this.translationService.instant('admin.tools.batchUpdate.form.properties.productionAvailability.valid');
        }

        if (this.toolPropertiesForm?.control('notValidForProduction')?.value === true) {
            return this.translationService.instant('admin.tools.batchUpdate.form.properties.productionAvailability.notValid');
        }

        return 'N/A'
    }

    get prodValidityReason() {
        return this.toolPropertiesForm?.control('validityReason')?.value
    }

    get infoMessage() {
        if (this.prodValidityProp) {
            return this.translationService.instant('admin.tools.batchUpdate.form.overview.messageWithProduction');
        }

        return this.translationService.instant('admin.tools.batchUpdate.form.overview.message');
    }

    get prodValidityValue() {
        if (this.toolPropertiesForm?.control('validForProduction')?.value === true) {
            return true;
        }

        if (this.toolPropertiesForm?.control('notValidForProduction')?.value === true) {
            return false;
        }

        return null;
    }

    ngAfterViewInit(): void {
        this.cdr.markForCheck();
    }
}
